import { QuestDefinition } from './types';

/**
 * Quest definition for the Manual Floor tool (ManualFloorTool / 'manual_floor')
 *
 * Maps internal phases to user-facing hint bar translation source strings.
 * These strings must be registered in apps/client/src/hooks/useToolTooltipState.ts
 * for the translation system to pick them up.
 */
export const manualFloorQuest: QuestDefinition = {
  toolName: 'manual_floor',
  states: {
    placing_floor: 'click the floor',
    placing_ceiling: 'click the ceiling',
  },
  defaultKey: 'click the floor',
};
